export class ModelTimelineDetail {

  constructor(
    public hash: string,
    public startTime: number,
    public endTime: number,
    public manufacturingOrderCode: string,
    public manufacturingOrderReference: string,
    public manufacturingOrderProject: string,
    public materialFilename: string,
    public materialDenomination: string,
    public printReference: string,
    public sourceName: string,
    public partName: string,
    public operationName: string,
    public programReference: string,
    public programTool: string,
    public programToolHolder: string,
    public execution: boolean,
    public preparation: boolean,
    public alarm: boolean,
    public stop: boolean,
    public maintenance: boolean,
    public pause: boolean,
    public eventName: string,
    public message: string
  ) { }

}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/summary/model-timeline-detail.ts